
/* styles */
require("!!../../node_modules/_extract-text-webpack-plugin@2.1.2@extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/style-compiler/index?{\"id\":\"data-v-2a8d22a9\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=styles&index=0!./Main.vue")

var Component = require("!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=script&index=0!./Main.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2a8d22a9\"}!../../node_modules/_vue-loader@11.3.4@vue-loader/lib/selector?type=template&index=0!./Main.vue"),
  /* scopeId */
  "data-v-2a8d22a9",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Main.vue
// module id = 37
// module chunks = 70